module.exports = __webpack_public_path__ + "img/tab-vehicle-row-side-hyundai.9d106ca2.png";